export enum Appearance {
    Filled = "filled",
    Transparent = "transparent",
    Bordered = "bordered",
    Simple = "simple",
    FullBleed = "full-bleed",
    Floating = "floating",
}
